import { useState } from 'react';

const Checkmark = ({ isChecked }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 21 21"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fillRule="nonzero" fill="none">
      <path
        d="M3.93 18.07a10 10 0 1 1 13.9-14.39 10 10 0 0 1-13.9 14.39z"
        fill={
          isChecked
            ? 'var(--bgBlueish__tintedText)'
            : 'var(--bgBlueish__fadedText)'
        }
      />
      <path
        fill={isChecked ? '#f4f5fa' : 'var(--bgBlueish__fadedText)'}
        d="M7.7 10.29L10 12.6l4.3-4.3 1.4 1.42L10 15.4l-3.7-3.7 1.4-1.42z"
      />
    </g>
  </svg>
);

export function RadioButtonGroup({
  componentKey,
  buttons,
  label,
  onChange,
  helperText = null,
  defaultKey = null,
  inlineWidth = false,
  name = null,
}) {
  const [internalKey, setInternalKey] = useState(defaultKey);

  function handleChange({ target }) {
    setInternalKey(target.value);

    onChange(target.value);
  }

  return (
    <div className="root">
      <div className="label">{label}</div>
      {helperText && <div className="helperText">{helperText}</div>}
      <div className="buttons">
        {buttons.map(({ key, value }) => (
          <div className="button" key={key}>
            <input
              className="button__input"
              type="radio"
              name={name || `__radio-button-group-${componentKey}-${key}`}
              id={`__radio-button-group-${componentKey}-${key}`}
              value={key}
              onChange={handleChange}
              checked={key === internalKey}
            />
            <label
              className="button__label"
              htmlFor={`__radio-button-group-${componentKey}-${key}`}
            >
              <Checkmark isChecked={key === internalKey} />
              {value}
            </label>
          </div>
        ))}
      </div>
      <style jsx>{`
        .root {
          margin-bottom: 18px;
        }

        .label {
          margin-bottom: 9px;
          font-weight: 600;
          color: var(--bgBlueish__text);
        }

        .helperText {
          margin-top: -7px;
          margin-bottom: 9px;
          color: var(--bgBlueish__fadedText);
          font-weight: 500;
          font-size: 14px;
        }

        .button {
          flex: 1;
          margin-right: 9px;
        }

        .button:last-child {
          margin-right: 0;
        }

        .button__input {
          position: absolute;
          opacity: 0;
        }

        .button__label {
          display: flex;
          align-items: center;
          height: 50px;
          background-color: var(--bgBlueish);
          border: 3px solid var(--bgBlueish__fadedText);
          border-radius: 4px;
          padding-right: 18px;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          color: var(--bgBlueish__text);
          box-sizing: border-box;
          cursor: pointer;
        }

        .button__label :global(svg) {
          margin: 0 9px;
        }

        .button__label:hover {
          border-color: var(--bgBlueish__tintedText);
        }

        .button__input:checked ~ .button__label {
          border-color: var(--bgBlueish__tintedText);
        }
      `}</style>
      <style jsx>{`
        .buttons {
          display: ${inlineWidth ? 'inline-flex' : 'flex'};
        }
      `}</style>
    </div>
  );
}
